export function isFoodPendingSession(user: any, subscription: any) {
  if (String(user?.role || '').toUpperCase() !== 'USER') return false
  if (user?.pendingActivation === true) return true
  return String(subscription?.status || '').toUpperCase() === 'PENDING'
}
